import { paserParams } from "../../until"
import axiosClient, { ResponseSuccess, ResponseSuccessTotal } from "../axiosClient"
import { IConditionSync } from "../groupCustomerV2/groupCustomerV2Api"
import tokenService from '../../services/token';
import { API_URL } from "../../env";
import axios from "axios";
import { ITag } from "../selectOptions/selectOptionsApi";

export interface ICustomer {
    customerId?: number
    customerCodeDms?: string
    dmsId?: string
    idTable?: number
    vehicleId: number
    id: number
    code: string
    name: string
    fields: ListFieldCustomer[]
    groupPermissionId: number
    permissionMenu: PermissionMenu
    originalId: number
    updatedAt: string

    ownerId?: number
    contactId?: number
    priority?: number
    conversionId?: number
    campaignId?: number
    isAutoCampaign?: boolean
    idVoucher?: number
    categoryCarId?: number
}

export interface ListFieldCustomer {
    fieldId: number
    fieldLabel: string
    fieldCode: string
    value: any
    view?: boolean
    edit?: boolean
    additionalData?: {
        colors: {
            bg: string
            text: string
            border: string
        }
    }
}

export interface PermissionMenu {
    groupPermissionId: number
    view: boolean
    edit: boolean
    delete: boolean
}




export interface ListField {
    id: number
    title: string
    fields: IField[]
}

export interface IField {
    id: number
    fieldCode: string
    fieldLabel: string
    inputType: string
    view?: boolean
    edit?: boolean
    isActive?: number
}
export interface FieldsUpdate {
    fieldId: number,
    isActive: number
}


export interface IListHistoryLog {
    id: number
    fullname: string
    code: string
    email: string
    img: string
    createdAt: string
    customerName: string
    cardIssuanceCode: string
    HistorySummaries: HistorySummary[]
}

export interface HistorySummary {
    id: number
    customerId?: number
    moduleId?: number
    parentId?: number
    level?: number
    description: string
    historyLogDetails: HistoryLogDetail[]
}

export interface HistoryLogDetail {
    customer?: Customer
    admin?: Admin
}

export interface Customer {
    username: string
}

export interface Admin {
    fullname: string
}

export interface IItemLast {
    lastId: number
    updatedAt: string
}


//----- 
export interface ISummaryRepair {
    totalMaintenanceCount?: number,
    totalMoney?: number,
    latestMaintenanceDate?: string
    daysSinceLastService?: number
}

export interface ICustomerRepair {
    summary: ISummaryRepair,
    data: ICustomer[]
}

export interface ISummaryContactHistory {
    latestInteractionDate?: string,
    totalInteractionCount?: number,
    customerLastAssessment?: string
}

export interface IVehicleInterestContactHistory {
    summary: ISummaryContactHistory,
    data: ICustomer[]
}


export interface IComplaintDetail {
    id: number
    adminId: number
    adminName?: string
    branchId?: number[]
    branchName?: string
    carId?: number
    vehicleId?: number
    carName?: string
    carLineId?: number
    carLineTitle?: string
    categoryId?: number
    categoryTitle: string
    interactionType?: string
    docCode?: string
    interactionCategory?: string
    chanelFbName: string
    docDate?: string
    docDateEndProc?: string
    docStatusEndName?: string
    plateNumber?: string
    plateNumberId?: number
    chassisNo?: string
    docResultName?: string
    complainName: string
    complaintType1Desc?: string
    employeeName?: string
    employeeCode?: string
    complainDesc?: string
    solution?: string
    note?: string
    regionId?: number
    regionName?: string
    processLevel?: string
    suspendReason?: string
    nextProcessDate?: string

}

export interface IListCustomerComplaintLogs {
    id: number
    dateCreate: string
    description: string
    adminCode: string
    adminName: string
    adminEmail: string
}
export interface InfoServiceSalesCare {
    id: number
    vehicleBookingDocCode: string
    adminId: any
    adminName: string
    branchId: number
    branchName: string
    carId: any
    vehicleId: any
    carName: any
    plateNumberId: any
    plateNumber: any
    chassisNo: any
    engineNo: any
    vehicleBookingProfitCenterCode: string
    contactType: any
    registrationDate: string
    maintenanceReminderDate: string
    currentMileageKm: any
    tentativeCustomerRequest: any
    vehicleBookingDescription: string
}

export interface IQuestionSurvey {
    id: number
    questionId: number
    questionContent: string
    answerId: number
    answerContent: string
    reason: string
}


export interface IInfoCarByContractNo {
    cars: ITag[]
    stockOutDates: string[]
}

export interface InfoRepairAppointment {
    id: number
    vehicleBookingDocCode: string
    adminId: number
    adminName: string
    adminCode: string
    branchId: number
    branchName: string
    routeId: any
    routeName: string
    carId: number
    vehicleId: number
    carName: string
    plateNumberId: number
    plateNumber: string
    chassisNo: string
    engineNo: string
    cabinNo: any
    vehicleBookingProfitCenterCode: string
    contactType: string
    registrationDate: string
    profitCenterName: any
    tentativeRegistrationDate: string
    registrationTime: any
    vehicleBookingEffectiveGetDate: string
    vehicleBookingEffectiveGetTime: any
    tentativeCustomerRequest: any
    isArrive: any
    dungHen: any
    saiHen: any
    repairAppointmentType: number
}


export interface InfoVehicleOwnership {
    id: number
    customerId: number
    customerCode: string
    customerName: string
    carName: string
    vehicleStatus: number
    invoiceSaleDocDate: string
    invoiceSaleBoxName: string
    engineType?: string
    vehicleId: number
    vehicleChassisNo: string
    vehicleColorId: number
    colorName1: string
    furnitureColorId: number
    furnitureColor: any
    madeYear: number
    categoryId: number
    paperReason?: string
    VehiclePlateNumbers: VehiclePlateNumber[]
    purposeOfUseId: number[]
    permission: IPermission
}

export interface IPermission {
    own_vehicle_name: IFieldPermission
    own_vehicle_status: IFieldPermission
    own_representative: IFieldPermission
    own_chassis_no: IFieldPermission
    own_number_plate: IFieldPermission
    own_color_name: IFieldPermission
    own_purchase_date: IFieldPermission
    own_made_year: IFieldPermission
    own_engine_type: IFieldPermission
    own_contact_channel: IFieldPermission
    own_sales_staff_name: IFieldPermission
    own_branch_name: IFieldPermission
    own_vehicle_type_category: IFieldPermission
    own_vehicle_group: IFieldPermission
    own_vehicle_brand: IFieldPermission
    own_accu_seri: IFieldPermission
    own_accu_seri1: IFieldPermission
    customer_name: IFieldPermission
    own_box_code: IFieldPermission
    own_engine_no: IFieldPermission
    own_interior_color: IFieldPermission
    old_owner_doc_date: IFieldPermission
    ownership_end_date: IFieldPermission
    paper_reason: IFieldPermission
    purpose_of_use: IFieldPermission
    receive_warranty_date: IFieldPermission
    end_warranty_date: IFieldPermission
}
export interface IFieldPermission {
    view: boolean;
    edit: boolean;
}

export interface VehiclePlateNumber {
    id: number
    plateNumber: string
}

export const getListCustomerRecyclebin = async (
    limit?: number, pageNumber?: number, search?: string, unitId?: number
) => {
    const path = "customer/listCustomerRecyclebin"
    const params = {
        limit, pageNumber, search, unitId
    }
    const result: ResponseSuccessTotal<ICustomer[]> = await axiosClient.get(path, { params });
    return result;
};


export const getListHistoryLog = async (
    id: number,
    adminId?: number, dateStart?: string, dateEnd?: string, search?: string
) => {
    const path = "groupCustomerV2/listHistoryLog"
    const params = {
        id,
        adminId, dateStart, dateEnd, search
    }
    const result: ResponseSuccessTotal<IListHistoryLog[]> = await axiosClient.get(path, { params });
    return result;
};



export const getInfoCustomerByFields = async (
    id: number,
    unitTempId?: number
) => {
    const path = "customer/infoCustomerByFields"
    const params = {
        id,
        unitTempId
    }
    const result: ResponseSuccessTotal<ICustomer> = await axiosClient.get(path, { params });
    return result;
};


export const getListCustomer_V2 = async (
    permittedCategoryCarIds: number[],
    limit?: number, pageNumber?: number, search?: string, sortTableGender?: number,
    sortTableBirthday?: number, unitId?: number, filterCustomerId?: number,
    businessCheck?: number[], ageMin?: number, ageMax?: number, gender?: Number[],
    listArea?: number[], listProvince?: number[], listDistrict?: number[],
    listProfession?: number[], listRank?: number[], statusMarital?: number[], listHobby?: number[],
    listCategoryCar?: number[], priceMin?: number, priceMax?: number, numberOwnedCar?: number,
    ownershipPeriodCar?: number, listUnit?: number[], listGroupCustomer?: number[], professionSelectAll?: number,
    hobbySelectAll?: number, unitSelectAll?: number, groupCustomerSelectAll?: number,
    fieldCode?: string[], listPhone?: string[], listType?: number[], listCode?: string[],
    listTaxCode?: string[], listPassport?: string[], dateStart?: string, dateEnd?: string,
    listFilter?: IConditionSync[], lastId?: number, lastUpdatedAt?: string

) => {
    const path = "customer/listCustomer"
    const params = {
        permittedCategoryCarIds,
        limit, pageNumber, search, sortTableGender,
        sortTableBirthday, unitId, filterCustomerId,
        businessCheck, ageMin, ageMax, gender,
        listArea, listProvince, listDistrict,
        listProfession, listRank, statusMarital, listHobby,
        listCategoryCar, priceMin, priceMax, numberOwnedCar,
        ownershipPeriodCar, listUnit, listGroupCustomer, professionSelectAll,
        hobbySelectAll, unitSelectAll, groupCustomerSelectAll,
        fieldCode, listPhone, listType, listCode,
        listTaxCode, listPassport, dateStart, dateEnd,
        listFilter: JSON.stringify(listFilter), lastId, lastUpdatedAt
    }
    const result: ResponseSuccessTotal<ICustomer[]> = await axiosClient.get(
        path, { params: paserParams(params, undefined) }
    );
    return result;
};

export const getListFieldsByCustomer = async (
    recordId: number, isActive?: number, type: number = 0, listFilter?: IConditionSync[], search?: string,
) => {
    const path = "profileCustomer/listFieldsByCustomerRecord"
    const params = {
        recordId, type,
        isActive, listFilter: JSON.stringify(listFilter), search,
    }
    const result: ResponseSuccessTotal<ListField[]> = await axiosClient.get(path, { params });
    return result;
};

export const updateFieldUser = async (
    adminId: number, recordId: number, type: number = 0, listFields: FieldsUpdate[]
) => {
    const path = "profileCustomer/editUserFieldSettings"
    const params = {
        adminId, recordId, type, listFields
    }
    const result: ResponseSuccess<[]> = await axiosClient.put(
        path, paserParams(params, undefined)
    );
    return result;
};

export const getListFieldsRecord = async () => {
    const path = "profileCustomer/listFieldsRecord"
    const result: ResponseSuccess<ListField[]> = await axiosClient.get(
        path, {}
    );
    return result;
};

export const exportListCustomerExcel = async (
    permittedCategoryCarIds: number[],
    limit?: number, pageNumber?: number, search?: string, sortTableGender?: number,
    sortTableBirthday?: number, unitId?: number, filterCustomerId?: number,
    businessCheck?: number[], ageMin?: number, ageMax?: number, gender?: Number[],
    listArea?: number[], listProvince?: number[], listDistrict?: number[],
    listProfession?: number[], listRank?: number[], statusMarital?: number[], listHobby?: number[],
    listCategoryCar?: number[], priceMin?: number, priceMax?: number, numberOwnedCar?: number,
    ownershipPeriodCar?: number, listUnit?: number[], listGroupCustomer?: number[], professionSelectAll?: number,
    hobbySelectAll?: number, unitSelectAll?: number, groupCustomerSelectAll?: number,
    fieldCode?: string[], listPhone?: string[], listType?: number[], listCode?: string[],
    listTaxCode?: string[], listPassport?: string[], dateStart?: string, dateEnd?: string,
    listFilter?: IConditionSync[], lastId?: number, listId?: number[]
) => {
    try {
        // 1. Kiểm tra URL
        const token = tokenService.getToken()
        const apiUrl = `${API_URL}${"customer/listCustomerExcel"}`

        const response = await axios.get(apiUrl, {
            params: {
                permittedCategoryCarIds,
                limit, pageNumber, search, sortTableGender,
                sortTableBirthday, unitId, filterCustomerId,
                businessCheck, ageMin, ageMax, gender,
                listArea, listProvince, listDistrict,
                listProfession, listRank, statusMarital, listHobby,
                listCategoryCar, priceMin, priceMax, numberOwnedCar,
                ownershipPeriodCar, listUnit, listGroupCustomer, professionSelectAll,
                hobbySelectAll, unitSelectAll, groupCustomerSelectAll,
                fieldCode, listPhone, listType, listCode,
                listTaxCode, listPassport, dateStart, dateEnd,
                listFilter: JSON.stringify(listFilter), lastId, listId
            },
            responseType: 'blob',
            headers: {
                'Authorization': `Bearer ${token}`,
            }
        });

        if (response.status === 200 && response.data) {
            const blob = new Blob([response.data]);
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `Danh sách khách hàng.xlsx`;
            a.click();
        }

    } catch (error) {
        console.error('Error:', error);
    }

};

//#region tab thông tin xe

//	update thông tin xe

export const editVehicleOwnership = async (
    detailId: number, vehicleStatus: number, paperReason: string, vehicleChassisNo: string,
    oldOwnerCustomerId?: number, newOwnerCustomerId?: number, vehicleId?: number, oldOwnerDocDate?: string,
    ownershipEndDate?: string, newOwnerDocDate?: string, oldVehiclePlateNumber?: string, newVehiclePlateNumber?: string,
    vehicleColorId?: number, furnitureColorId?: number, madeYear?: number, engineType?: string,
    box?: string, purposeOfUseId?: number[]
) => {

    const url = "customer/updateVehicleOwnership";
    const params = {
        detailId, vehicleStatus, paperReason, vehicleChassisNo,
        oldOwnerCustomerId, newOwnerCustomerId, vehicleId, oldOwnerDocDate,
        ownershipEndDate, newOwnerDocDate, oldVehiclePlateNumber, newVehiclePlateNumber,
        vehicleColorId, furnitureColorId, madeYear, engineType,
        box, purposeOfUseId
    }
    const result: ResponseSuccess<[]> = await axiosClient.post(
        url, paserParams(params, undefined)
    );
    return result;
}

// infoXe 
export const getInfoVehicleOwnership = async (
    customerId: number, detailId?: number,
) => {
    const path = "customer/infoVehicleOwnership"
    const params = {
        customerId, detailId
    }
    const result: ResponseSuccess<InfoVehicleOwnership> = await axiosClient.get(path, {
        params
    });
    return result;
};

///xe /customer/listCustomerVehicle
export const getListCustomerVehicle = async (
    customerId: number, type: number, unitTempId: number = 0, permittedCategoryCarIds: number[] = [],
    status?: number[]
) => {
    const path = "customer/listCustomerVehicle"
    const params = {
        customerId, type, unitTempId, permittedCategoryCarIds,
        status
    }
    const result: ResponseSuccess<ICustomer[]> = await axiosClient.get(path, {
        params
    });
    return result;
};

//customer/listCustomerInvoices  hf
export const getListCustomerInvoices = async (
    customerId: number, vehicleId: number, unitTempId: number, permittedCategoryCarIds: number[],
    limit?: number, pageNumber?: number,
) => {
    const path = "customer/listCustomerInvoices"
    const params = {
        customerId, vehicleId, unitTempId, permittedCategoryCarIds,
        limit, pageNumber
    }
    const result: ResponseSuccessTotal<ICustomer[]> = await axiosClient.get(path, {
        params
    });
    return result;
};

//customer/listCustomerInsurance  bảo hiểm
export const getListCustomerInsurance = async (
    customerId: number, vehicleId: number, unitTempId: number, permittedCategoryCarIds: number[],
    limit?: number, pageNumber?: number,
) => {
    const path = "customer/listCustomerInsurance"
    const params = {
        customerId, vehicleId, unitTempId, permittedCategoryCarIds,
        limit, pageNumber
    }
    const result: ResponseSuccessTotal<ICustomer[]> = await axiosClient.get(path, {
        params
    });
    return result;
};

//customer/listCustomerRepair  sửa chữa
export const getListCustomerRepair = async (
    customerId: number, vehicleId: number, unitTempId: number, permittedCategoryCarIds: number[],
    limit?: number, pageNumber?: number,  type?: number
) => {
    const path = "customer/listCustomerRepair"
    const params = {
        customerId, vehicleId, unitTempId, permittedCategoryCarIds,
        limit, pageNumber, type
    }
    const result: ResponseSuccessTotal<ICustomerRepair> = await axiosClient.get(path, {
        params
    });
    return result;
};

//customer/listCustomerInteractions  ls tiếp xúc
export const getListCustomerInteractions = async (
    customerId: number, customerCodeDms: string, unitTempId: number, permittedCategoryCarIds: number[],
    limit?: number, pageNumber?: number,
) => {
    const path = "customer/listCustomerInteractions"
    const params = {
        customerId, customerCodeDms, unitTempId, permittedCategoryCarIds,
        limit, pageNumber
    }
    const result: ResponseSuccessTotal<IVehicleInterestContactHistory> = await axiosClient.get(path, {
        params
    });
    return result;
};

//customer/listCustomerInterested  xe quan ls tiếp xúc
export const getListVehicleInterestContactHistory = async (
    vehicleId: number, customerId: number, dmsId: string, unitTempId: number, permittedCategoryCarIds: number[],
    limit?: number, pageNumber?: number,
) => {
    const path = "customer/listCustomerInterested"
    const params = {
        vehicleId, customerId, dmsId, unitTempId, permittedCategoryCarIds,
        limit, pageNumber
    }
    const result: ResponseSuccessTotal<IVehicleInterestContactHistory> = await axiosClient.get(path, {
        params
    });
    return result;
};
//#endregion

//#endregion

//#region Tab Lịch sử hóa đơn



export interface IInvoiceSummaryByMonth {
    month: number
    saleTotal: number
    serviceTotal: number
}


//Thống kê hóa đơn theo tháng
export const getInvoiceSummaryByMonth = async (
    customerId: number, year: number
) => {
    const path = "customer/invoiceSummaryByMonth"
    const params = {
        customerId, year
    }
    const result: ResponseSuccess<IInvoiceSummaryByMonth[]> = await axiosClient.get(path, {
        params
    });
    return result;
};

export const getListSaleInvoices = async (
    customerId: number, unitTempId: number, permittedCategoryCarIds: number[],
    detailId?: number, limit?: number, pageNumber?: number, vehicleChassisNo?: string[],
    unitId?: number[]
) => {
    const path = "customer/listSaleInvoices"
    const params = {
        customerId, unitTempId, permittedCategoryCarIds,
        detailId, limit, pageNumber, vehicleChassisNo,
        unitId
    }
    const result: ResponseSuccessTotal<ICustomer[]> = await axiosClient.get(path, {
        params
    });
    return result;
};

///customer/listServiceInvoices
export const getListServiceInvoices = async (
    customerId: number, unitTempId: number, permittedCategoryCarIds: number[],
    detailId?: number, limit?: number, pageNumber?: number, vehicleChassisNo?: string[],
    branchId?: number[]
) => {
    const path = "customer/listServiceInvoices"
    const params = {
        customerId, unitTempId, permittedCategoryCarIds,
        detailId, limit, pageNumber, vehicleChassisNo,
        branchId
    }
    const result: ResponseSuccessTotal<ICustomer[]> = await axiosClient.get(path, {
        params
    });
    return result;
};
//#endregion


//#region Tab lịch sử tương tác

//Danh sách chăm sóc bán hàng, dịch vụ
export const getListCustomerCareAndService = async (
    customerId: number, unitTempId: number, permittedCategoryCarIds: number[],
    detailId?: number, limit?: number, pageNumber?: number,
) => {
    const path = "customer/listCustomerCareAndService"
    const params = {
        customerId, unitTempId, permittedCategoryCarIds,
        detailId, limit, pageNumber
    }
    const result: ResponseSuccessTotal<ICustomer[]> = await axiosClient.get(path, {
        params
    });
    return result;
};

//Danh sách chi tiết chăm sóc bán hàng, dịch vụ
export const getInfoServiceSalesCare = async (
    id: number,
) => {
    const path = "customer/infoServiceSalesCare"
    const params = {
        id
    }
    const result: ResponseSuccessTotal<InfoServiceSalesCare> = await axiosClient.get(path, {
        params
    });
    return result;
};

//Danh sách chi tiết sửa chữa
export const getInfoRepairAppointment = async (
    id: number,
) => {
    const path = "customer/infoRepairAppointment"
    const params = {
        id
    }
    const result: ResponseSuccessTotal<InfoRepairAppointment> = await axiosClient.get(path, {
        params
    });
    return result;
};

//	Danh sách lịch sử hỗ trợ, khiếu nại
export const getListCustomerComplaints = async (
    customerId: number, unitTempId: number, permittedCategoryCarIds: number[],
    detailId?: number, limit?: number, pageNumber?: number,
) => {
    const path = "customer/listCustomerComplaints"
    const params = {
        customerId, detailId, unitTempId, permittedCategoryCarIds,
        limit, pageNumber
    }
    const result: ResponseSuccessTotal<ICustomer[]> = await axiosClient.get(path, {
        params
    });
    return result;
};

//Danh sách thông tin khảo sát
export const getListCustomerSurvey = async (
    customerId: number, unitTempId: number, permittedCategoryCarIds: number[],
    detailId?: number, limit?: number, pageNumber?: number,
) => {
    const path = "customer/listCustomerSurvey"
    const params = {
        customerId, detailId, unitTempId, permittedCategoryCarIds,
        limit, pageNumber
    }
    const result: ResponseSuccessTotal<ICustomer[]> = await axiosClient.get(path, {
        params
    });
    return result;
};

//Danh sách thông tin marketing
export const getListClientCampaign = async (
    customerId: number, unitTempId: number, permittedCategoryCarIds: number[],
    limit?: number, pageNumber?: number, search?: string, fromDate?: string, toDate?: string
) => {
    const path = "customer/listClientCampaign"
    const params = {
        customerId, unitTempId, permittedCategoryCarIds,
        limit, pageNumber, search, fromDate, toDate
    }
    const result: ResponseSuccessTotal<ICustomer[]> = await axiosClient.get(path, {
        params
    });
    return result;
};

//Danh sách thông tin voucher
export const getListClientVoucher = async (
    customerId: number, unitTempId: number, permittedCategoryCarIds: number[],
    limit?: number, pageNumber?: number, search?: string, fromDate?: string, toDate?: string
) => {
    const path = "customer/listClientVoucher"
    const params = {
        customerId, unitTempId, permittedCategoryCarIds,
        limit, pageNumber, search, fromDate, toDate

    }
    const result: ResponseSuccessTotal<ICustomer[]> = await axiosClient.get(path, {
        params
    });
    return result;
};

//#region modal chăm sóc bán hàng, dịch vụ

// danh sách lịch sử nội dung liên hệ Ghi chú thông tin chăm sóc bán hàng, dịch vụ
export const getListServiceSalesCareLogs = async (
    limit?: number, pageNumber?: number, customerId?: number, vehicleBookingId?: number
) => {
    const path = "customer/listServiceSalesCareLogs";
    const params = {
        limit, pageNumber, customerId, vehicleBookingId
    }
    const result: ResponseSuccessTotal<IListCustomerComplaintLogs[]> = await axiosClient.get(path, {
        params
    });
    return result;
}

//	Thêm nội dung liên hệ
export const addServiceSalesCareLogs = async (
    customerId: number, vehicleBookingId: number, adminId: number, description: string
) => {
    const url = "customer/addServiceSalesCareLogs";
    const params = {
        customerId, vehicleBookingId, adminId, description
    }
    const result: ResponseSuccess<[]> = await axiosClient.post(
        url, paserParams(params, undefined)
    );
    return result;
}

///	Tạo lịch hẹn sửa chữa thành công
export const addRepairAppointment = async (
    customerId: number, vehicleBookingDocCode: string, registrationDate: string,
    tentativeRegistrationDate?: string, registrationTime?: string, contactType?: string, profitCenterName?: string,
    carId?: number, vehicleId?: number, numberPlateId?: number, chassisNo?: string, engineNo?: string,
    adminId?: number, cabinNo?: string, vehicleBookingEffectiveGetDate?: string, vehicleBookingEffectiveGetTime?: string,
    branchId?: number, routeId?: number, tentativeCustomerRequest?: string, isArrive?: boolean,
    dungHen?: boolean, saiHen?: boolean
) => {

    const url = "customer/addRepairAppointment";
    const params = {
        customerId, vehicleBookingDocCode, registrationDate, tentativeRegistrationDate,
        registrationTime,
        contactType, profitCenterName, carId, vehicleId, numberPlateId,
        chassisNo, engineNo, adminId, cabinNo,
        vehicleBookingEffectiveGetDate, vehicleBookingEffectiveGetTime, branchId, routeId,
        tentativeCustomerRequest, isArrive, dungHen, saiHen
    }
    const result: ResponseSuccess<[]> = await axiosClient.post(
        url, paserParams(params, undefined)
    );
    return result;
}

///	Cập nhât lịch hẹn sửa chữa thành công
export const editRepairAppointment = async (
    id: number, customerId: number, vehicleBookingDocCode: string, registrationDate: string,
    tentativeRegistrationDate?: string, registrationTime?: string, contactType?: string, profitCenterName?: string,
    carId?: number, vehicleId?: number, numberPlateId?: number, chassisNo?: string, engineNo?: string,
    adminId?: number, cabinNo?: string, vehicleBookingEffectiveGetDate?: string, vehicleBookingEffectiveGetTime?: string,
    branchId?: number, routeId?: number, tentativeCustomerRequest?: string, isArrive?: boolean,
    dungHen?: boolean, saiHen?: boolean
) => {

    const url = "customer/editRepairAppointment";
    const params = {
        id, customerId, vehicleBookingDocCode, registrationDate, tentativeRegistrationDate,
        registrationTime,
        contactType, profitCenterName, carId, vehicleId, numberPlateId: undefined,
        chassisNo, engineNo, adminId, cabinNo,
        vehicleBookingEffectiveGetDate, vehicleBookingEffectiveGetTime, branchId, routeId,
        tentativeCustomerRequest, isArrive, dungHen, saiHen
    }
    const result: ResponseSuccess<[]> = await axiosClient.post(
        url, paserParams(params, undefined)
    );
    return result;
}


///	Tạo chăm sóc bán hàng dịch vụ
export const addServiceSalesCare = async (
    customerId: number, vehicleBookingDocCode: string, registrationDate: string,
    contactType?: string, carId?: number, vehicleId?: number, numberPlateId?: number, chassisNo?: string,
    engineNo?: string, currentMileageKm?: number, maintenanceReminderDate?: string, adminId?: number,
    branchId?: number, vehicleBookingDescription?: string
) => {

    const url = "customer/addServiceSalesCare";
    const params = {
        customerId, vehicleBookingDocCode, registrationDate,
        contactType, carId, vehicleId, numberPlateId, chassisNo,
        engineNo, currentMileageKm, maintenanceReminderDate, adminId,
        branchId, vehicleBookingDescription
    }
    const result: ResponseSuccess<[]> = await axiosClient.post(
        url, paserParams(params, undefined)
    );
    return result;
}
//	update chăm sóc bán hàng dịch vụ
export const editServiceSalesCare = async (
    id: number, customerId: number, vehicleBookingDocCode: string, registrationDate: string,
    contactType?: string, carId?: number, vehicleId?: number, numberPlateId?: number, chassisNo?: string,
    engineNo?: string, currentMileageKm?: number, maintenanceReminderDate?: string, adminId?: number,
    branchId?: number, vehicleBookingDescription?: string
) => {

    const url = "customer/editServiceSalesCare";
    const params = {
        id, customerId, vehicleBookingDocCode, registrationDate,
        contactType, carId, vehicleId, numberPlateId: undefined, chassisNo,
        engineNo, currentMileageKm, maintenanceReminderDate, adminId,
        branchId, vehicleBookingDescription
    }
    const result: ResponseSuccess<[]> = await axiosClient.post(
        url, paserParams(params, undefined)
    );
    return result;
}

//#endregion


//#region modal lịch sử hỗ trợ, khiếu nại


//	Thêm nội dung tương tác
export const addCustomerComplaintLogs = async (
    customerId: number, complaintId: number, adminId: number, description: string
) => {
    const url = "customer/addCustomerComplaintLogs";
    const params = {
        customerId, complaintId, adminId, description
    }
    const result: ResponseSuccess<[]> = await axiosClient.post(
        url, paserParams(params, undefined)
    );
    return result;
}


///	Thêm khiếu nại thành công
export const addCustomerComplaint = async (
    customerId: number, docCode: string, chanelFbName: string, docDate: string,
    interactionCategory?: string, docDateEndProc?: string, docStatusEndName?: string, docResultName?: string,
    carId?: number, vehicleId?: number, plateNumberId?: number, chassisNo?: string, complainName?: string,
    adminId?: number, branchId?: number[], regionId?: number,
    processLevel?: number, complainDesc?: string, solution?: string, note?: string,
    suspendReason?: string, nextProcessDate?: string,
    type?: number
) => {
    const url = "customer/addCustomerComplaint";
    const params = {
        customerId, docCode, chanelFbName, docDate,
        interactionCategory, docDateEndProc, docStatusEndName, docResultName,
        carId, vehicleId, plateNumberId, chassisNo, complainName,
        adminId, branchId, regionId,
        processLevel, complainDesc, solution, note,
        suspendReason, nextProcessDate,
        type
    }
    const result: ResponseSuccess<[]> = await axiosClient.post(
        url, paserParams(params, undefined)
    );
    return result;
}

export const getListCustomerComplaintLogs = async (
    limit?: number, pageNumber?: number, customerId?: number, complaintId?: number
) => {
    const path = "customer/listCustomerComplaintLogs";
    const params = {
        limit, pageNumber, customerId, complaintId
    }
    const result: ResponseSuccessTotal<IListCustomerComplaintLogs[]> = await axiosClient.get(path, {
        params
    });
    return result;
}


export const getInfoCustomerComplaint = async (
    id: number
) => {
    const path = "customer/infoCustomerComplaint";
    const params = {
        id
    }
    const result: ResponseSuccess<IComplaintDetail> = await axiosClient.get(path, {
        params
    });
    return result;
}

///Cập nhật nại thành công
export const editCustomerComplaint = async (
    id: number, docCode: string, chanelFbName: string, docDate: string,
    interactionCategory?: string, docDateEndProc?: string, docStatusEndName?: string, docResultName?: string,
    carId?: number, vehicleId?: number, plateNumberId?: number, chassisNo?: string, complainName?: string,
    adminId?: number, branchId?: number[], regionId?: number,
    processLevel?: number, complainDesc?: string, solution?: string, note?: string,
    suspendReason?: string, nextProcessDate?: string,
    type?: number
) => {
    const path = "customer/editCustomerComplaint";
    const params = {
        id, docCode, chanelFbName, docDate,
        interactionCategory, docDateEndProc, docStatusEndName, docResultName,
        carId: undefined, vehicleId, plateNumberId: undefined, chassisNo, complainName,
        adminId, branchId, regionId,
        processLevel, complainDesc, solution, note,
        suspendReason, nextProcessDate,
        type
    }
    const result: ResponseSuccess<[]> = await axiosClient.put(
        path, params
    );
    return result;
}

//#endregion

//#endregion

//#region modal Thông tin khảo sát
// apiChild/infoQuestionSurvey?surveyId=614
// chi tiết câu hỏi khảo sát
export const getInfoQuestionSurvey = async (
    surveyId: number
) => {
    const path = "apiChild/infoQuestionSurvey";
    const params = {
        surveyId
    }
    const result: ResponseSuccess<IQuestionSurvey[]> = await axiosClient.get(path, {
        params
    });
    return result;
}

//	Thông tin xe theo hóa đơn
export const getListCarByInvoiceNo = async (
    customerId: number, invoiceNo: number
) => {
    const path = "customer/listCarByInvoiceNo";
    const params = {
        customerId, invoiceNo
    }
    const result: ResponseSuccess<IComplaintDetail> = await axiosClient.get(path, {
        params
    });
    return result;
}

// //Thông tin xe theo hợp đồng
// export const getInfoCarByContractNo = async (
//     customerId: number, contractNo: number
// ) => {
//     const path = "customer/infoCarByContractNo";
//     const params = {
//         customerId, contractNo
//     }
//     const result: ResponseSuccess<IInfoCarByContractNo> = await axiosClient.get(path, {
//         params
//     });
//     return result;
// }

//Danh sách biển số theo hợp đồng.
export const getListPlateNumberByContractNo = async (
    customerId: number, contractNo: number
) => {
    const path = "customer/listPlateNumberByContractNo";
    const params = {
        customerId, contractNo
    }
    const result: ResponseSuccess<any> = await axiosClient.get(path, {
        params
    });
    return result;
}

// Danh sách biển số theo hóa đơn.
export interface IInfoSurvey {
    id: number
    customerId: number
    surveyType: string
    contactType: string
    docDate?: string
    carId?: number
    vehicleId?: number
    carName?: string
    numberPlateId: any
    numberPlate?: string
    chassisNo: string
    engineNo: string
    branchId: number
    branchName: string
    adminId: number
    adminName: string
    adminCode: string
    invoiceNo?: string,
    contractNo?: string,
    deliveryDate?: string,
    presentMileAge?: number,
    questionList: QuestionList[]
}

export interface QuestionList {
    id: number
    questionId: number
    questionContent: string
    answerId: number
    answerContent: string
    reason: string
}


export const getListPlateNumberByInvoiceNo = async (
    customerId: number, invoiceNo: number
) => {
    const path = "customer/listPlateNumberByInvoiceNo";
    const params = {
        customerId, invoiceNo
    }
    const result: ResponseSuccess<any> = await axiosClient.get(path, {
        params
    });
    return result;
}

export const addCustomerSurvey = async (
    customerId: number, surveyType: string, docDate: string,
    contactType?: string, carId?: number, numberPlateId?: number, chassisNo?: string,
    engineNo?: string, invoiceNo?: string, contractNo?: string, deliveryDate?: string,
    presentMileAge?: number, adminId?: number, branchId?: number, questionList?: any[],
    vehicleId?: number
) => {
    const url = "customer/addCustomerSurvey";
    const params = {
        customerId, surveyType, docDate,
        contactType, carId: undefined, numberPlateId: undefined, chassisNo,
        engineNo, invoiceNo, contractNo, deliveryDate,
        presentMileAge, adminId, branchId, questionList,
        vehicleId
    }
    const result: ResponseSuccess<[]> = await axiosClient.post(
        url, paserParams(params, undefined)
    );
    return result;
}



export const getInfoCustomerSurvey = async (
    id: number
) => {
    const url = "/customer/infoCustomerSurvey";
    const params = {
        id
    }
    const result: ResponseSuccess<IInfoSurvey> = await axiosClient.get(url, {
        params
    });
    return result;
}

export const editCustomerSurvey = async (
    id: number, customerId: number, surveyType: string, docDate: string,
    contactType?: string, carId?: number, numberPlateId?: number, chassisNo?: string,
    engineNo?: string, invoiceNo?: string, contractNo?: string, deliveryDate?: string,
    presentMileAge?: number, adminId?: number, branchId?: number, questionList?: any[],
    vehicleId?: number
) => {
    const url = "/customer/editCustomerSurvey";
    const params = {
        id, customerId, surveyType, docDate,
        contactType, carId: undefined, numberPlateId: undefined, chassisNo,
        engineNo, invoiceNo, contractNo, deliveryDate,
        presentMileAge, adminId, branchId, questionList,
        vehicleId
    }
    const result: ResponseSuccess<[]> = await axiosClient.put(
        url, paserParams(params, undefined)
    );
    return result;
}
//#endregion